/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Create_DescriptionInputs */

const en_admin_categories_create_description = /** @type {(inputs: Admin_Categories_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a new content category`)
};

/**
* | output |
* | --- |
* | "Add a new content category" |
*
* @param {Admin_Categories_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_categories_create_description = /** @type {((inputs?: Admin_Categories_Create_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Create_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_categories_create_description(inputs)
});
export { admin_categories_create_description as "admin.categories.create_description" }